import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WandFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M15.9176 5.62691L20.9283 3.07383L18.3752 8.08454L22.3518 12.0611L16.7973 11.1813L14.2443 16.192L13.3645 10.6376L7.81012 9.75789L12.8208 7.2048L11.9411 1.65039L15.9176 5.62691ZM1.19995 21.6011L9.26084 13.54L10.5337 14.8127L2.47276 22.8739L1.19995 21.6011Z"
      />
    </SvgIcon>
  );
});
